import { keyframes } from "@mui/material";

export const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(38, 41, 59, 0.6);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 12px rgba(38, 41, 59, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(38, 41, 59, 0);
  }
`;

export const rotateIn = keyframes`
  from {
    transform: rotate(-90deg) scale(0);
    opacity: 0;
  }
  to {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
`;

export const rotateOut = keyframes`
  from {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
  to {
    transform: rotate(90deg) scale(0);
    opacity: 0;
  }
`;

export const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

export const slideInAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const confettiAnimation = keyframes`
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(-100px) rotate(720deg);
    opacity: 0;
  }
`;

export const progressGradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

/** Sweeps a short bar across its track when there is no percentage to show. */
export const progressSweepAnimation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
`;
